import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import ukTranslation from "./locales/uk/translation";
i18next.use(initReactI18next).init({
    resources: {
        uk: {
            translation: ukTranslation,
        },
    },
    lng: "uk",
    fallbackLng: "uk",
    interpolation: {
        escapeValue: false,
    },
});
export default i18next;
